import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatCurrency } from '../lib/format';

export interface EnterpriseLeaveRequest {
  id: number | string;
  employee_name: string;
  leave_type_name: string;
  start_date: string;
  end_date: string;
  status: string;
}

export interface EnterpriseLoan {
  id: number | string;
  employee_name: string;
  loan_amount: number;
  balance: number;
  status: string;
}

export interface EnterpriseLeaveQueueCardProps {
  requests: EnterpriseLeaveRequest[];
}

export const EnterpriseLeaveQueueCard: FC<EnterpriseLeaveQueueCardProps> = ({ requests }) => {
  const { t } = useTranslation();

  return (
    <article className="card list-card">
      <div className="section-header">
        <h2>{t('enterpriseLeaveQueue')}</h2>
        <span className="helper">{requests.length} {t('employees').toLowerCase()}</span>
      </div>
      {requests.length ? (
        <ul className="list">
          {requests.map((leaveRequest) => (
            <li key={leaveRequest.id}>
              <div>
                <strong>{leaveRequest.employee_name}</strong>
                <span>
                  {leaveRequest.leave_type_name} • {leaveRequest.start_date} to {leaveRequest.end_date} • {leaveRequest.status}
                </span>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p>{t('noLeaveRequests')}</p>
      )}
    </article>
  );
};

export interface LoanRegisterCardProps {
  loans: EnterpriseLoan[];
  activeLanguage: string;
}

export const LoanRegisterCard: FC<LoanRegisterCardProps> = ({ loans, activeLanguage }) => {
  const { t } = useTranslation();

  return (
    <article className="card list-card">
      <div className="section-header">
        <h2>{t('loanRegister')}</h2>
        <span className="helper">{loans.length} {t('employees').toLowerCase()}</span>
      </div>
      {loans.length ? (
        <ul className="list">
          {loans.map((loan) => (
            <li key={loan.id}>
              <div>
                <strong>{loan.employee_name}</strong>
                <span>
                  {formatCurrency(loan.loan_amount, activeLanguage)} • {formatCurrency(loan.balance, activeLanguage)} • {loan.status}
                </span>
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <p>{t('noLoans')}</p>
      )}
    </article>
  );
};
